module.exports = "/_next/static/images/ef59223fdcc578f0138a2c847009cee1-challenge-the-system-md@3x.jpg";